// <head> metadata for ServerlessPastPresentFuturePage (https://www.dbos.dev/serverless-past-present-future).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: "Webcast: Why Didn't Serverless Take Off?",
    },
    {
      name: 'description',
      content:
        'Live webcast January 29: DBOS CEO Jeremy Edberg talks about the past, present, and future of serverless computing based on his engineering experience at Reddit, Netflix, DBOS, and others.',
    },
    {
      property: 'og:title',
      content: "Webcast: Why Didn't Serverless Take Off?",
    },
    {
      property: 'og:description',
      content:
        'Live webcast January 29: DBOS CEO Jeremy Edberg talks about the past, present, and future of serverless computing based on his engineering experience at Reddit, Netflix, DBOS, and others.',
    },
    {
      property: 'og:image',
      content:
        'https://www.dbos.dev/assets/images/678497cf1db4f46f4da176bb_Jan-2025-Webcast-Why-Serverless-Past-Present-Future-1200-x-630-px.png',
    },
    {
      name: 'twitter:title',
      content: "Webcast: Why Didn't Serverless Take Off?",
    },
    {
      name: 'twitter:description',
      content:
        'Live webcast January 29: DBOS CEO Jeremy Edberg talks about the past, present, and future of serverless computing based on his engineering experience at Reddit, Netflix, DBOS, and others.',
    },
    {
      name: 'twitter:image',
      content:
        'https://www.dbos.dev/assets/images/678497cf1db4f46f4da176bb_Jan-2025-Webcast-Why-Serverless-Past-Present-Future-1200-x-630-px.png',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/serverless-past-present-future',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
